<template>
  <div class="charging-mode">
    <span class="homepage-title">告警占比</span>
    <div style="width:100%;height:95%;" id="charging-mode"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  data() {
    return {
      list:{},
      sun:"",
    };
  },
  mounted() {
    // this.drawChart();
    
    this.$nextTick(function() {
      if(localStorage.getItem("token")
      ){this.getEchartData();}
      // this.getEchartData();
    });
  },
  methods: {
    getEchartData(){
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action:"getAlarms",
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
        // .then(su => {
          let su=this.$store.state.alarmType
          if(su.data.code == 1){
            this.list = su.data.list;
            for(let i in this.list){
              this.sum = this.list.hardware + this.list.network + this.list.order;
            }
            this.drawChart(this.list);
            
          } else if(su.data.code == 0){
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        // })
        // .catch(err => {
        // });
    },
    drawChart(list){
      let echart = echarts.init(document.getElementById("charging-mode"));
      var option = {
        color: [
          "#FF787A",
          "#4d8fff",
          "#35b568",
        ],
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 120,
          bottom: 20,
          data: ['硬件告警','网络告警','订单告警'],
          textStyle: { color: "#6DC3FC" },
        },
        graphic: [//饼图中间数字和文字显示
          {
            type: "text",
            left: "33%",
            top: "140px",
            z: 2,
            zlevel: 100,
            style: {
              text: "告警总数",
              fill: "#FFFFFD",
              font: "bold 14px Microsoft YaHei"
            }
          },
          {
            type: "text",
            left: "38%",
            bottom: "80px",
            z: 2,
            zlevel: 100,
            style: {
              text: this.sum,
              fill: "#FF7A7D",
              font: "bold 26px Microsoft YaHei"
            }
          }
        ],
        series : [
          {
            name: '告警占比',
            type: "pie",
            radius: ["42%", "55%"],
            center: ['40%', '60%'],
            data:[
              {value:list.hardware, name:'硬件告警'},
              {value:list.network, name:'网络告警'},
              {value:list.order, name:'订单告警'}
            ],
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: true
                },
                borderWidth: 4,//每个扇形直接留有空隙
                borderColor: "#0C1E2A",//空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                },
              },
            },
          }
        ]
      };
      echart.setOption(option);
    },
  }
};
</script>

<style scoped lang="scss">
.charging-mode {
    width: 48%;
    height: 286px;
    float: left;
    position: relative;
    .homepage-title {
      color: #fffffd;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index/chargingModeChart.vue